import { render, staticRenderFns } from "./MiniKaskoOtpSection.vue?vue&type=template&id=09c99018&scoped=true&"
import script from "./MiniKaskoOtpSection.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoOtpSection.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoOtpSection.vue?vue&type=style&index=0&id=09c99018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c99018",
  null
  
)

export default component.exports